import React from 'react';
import { salesProof } from '../data/salesProof';
export function SeatsToday({
  className = ''
}: {
  className?: string;
}) {
  const seats = salesProof.seatsToday;
  if (seats <= 0) return null;
  return <p className={`flex items-center justify-center gap-2.5 rounded-xl bg-white/[0.06] px-4 py-3 text-[15px] font-semibold text-white ring-1 ring-white/10 ${className}`} data-id="element-400" data-mp="1ggljv6enwtdp">
      <span aria-hidden="true" className="relative flex h-2.5 w-2.5 shrink-0" data-id="element-401" data-mp="293z6aakqi6jk">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sun opacity-60 motion-reduce:animate-none" data-id="element-402" data-mp="2d62vs348nbnu" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-sun" data-id="element-403" data-mp="1zfha66negnm9" />
      </span>
      <span data-id="element-404" data-mp="24cza57jfvsi4">
        Cupos disponibles hoy: <strong className="font-heading text-lg font-black text-sun" data-id="element-405" data-mp="24c7mqjzzx12x">{seats}</strong>
      </span>
    </p>;
}